import React from "react";
import { Link } from "react-router-dom";
import RightArrowThin from "../SVG/RightArrowThin";
import "./CourseCard.css";

const CourseCard = ({ course }) => {
  const detailsUrl = `/course-details?courseId=${encodeURIComponent(course.id)}`;

  return (
    <article className="it-course-item ed-course-style-2 h-100">
      <Link className="course-card-cover mb-25" to={detailsUrl}>
        <span className="course-card-stage">
          {course.academic_level?.academic_stage?.name || "Cycle non renseigné"}
        </span>
        <h2 className="course-card-name">{course.name}</h2>
      </Link>
      <div className="it-course-content p-relative">
        <p className="pb-15 mb-30">
          {course.description?.trim() || "Aucune description disponible."}
        </p>
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center">
          <div className="it-course-author">
            <span>{course.academic_level?.name || "Niveau non renseigné"}</span>
          </div>
          <Link className="ed-course-btn" to={detailsUrl}>
            Voir détails <span><RightArrowThin /></span>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default CourseCard;
